module.exports = __webpack_public_path__ + "img/068.220e2bb8.png";